import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'payments-header',
  templateUrl: './payments-header.component.html'
})
export class PaymentsHeaderComponent implements OnInit {
  @Input() allInvoicesSum: number;
  @Input() closedInvoicesSum: number;
  @Input() pendingInvoicesSum: number;
  @Input() userInfo: any;

  constructor() { }

  ngOnInit(): void {
  }


  get total() {
    return this.allInvoicesSum;
  }


}
